import { render, staticRenderFns } from "./ContactInfo.vue?vue&type=template&id=e32cc1a8"
import script from "./ContactInfo.vue?vue&type=script&lang=ts"
export * from "./ContactInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e32cc1a8')) {
      api.createRecord('e32cc1a8', component.options)
    } else {
      api.reload('e32cc1a8', component.options)
    }
    module.hot.accept("./ContactInfo.vue?vue&type=template&id=e32cc1a8", function () {
      api.rerender('e32cc1a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contacts/ContactInfo.vue"
export default component.exports